module.exports = __webpack_public_path__ + "img/dbcping_358.271fa5f6.jpg";